import { useEffect, type ReactNode } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { AuthProvider, useAuth } from "@/lib/auth/AuthContext";

function AuthGateInner({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, login } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [isLoading, isAuthenticated, login]);

  if (isLoading || !isAuthenticated) {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress size={56} />
          <Typography sx={{ mt: 2, fontSize: "1.35rem", fontWeight: 700 }}>
            {isLoading ? "Checking sign-in…" : "Redirecting to login…"}
          </Typography>
        </Box>
      </Box>
    );
  }

  return <>{children}</>;
}

/** OIDC-gated shell shared by /dashboard and /configuration. */
export function AuthenticatedAppShell({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <AuthGateInner>{children}</AuthGateInner>
    </AuthProvider>
  );
}
